import angular from 'angular';
import { InputChavePixController } from './input-chave-pix.controller';
import { InputChavePixComponent } from './input-chave-pix.component';

export const InputChavePixModule = angular.module('InputChavePixModule', ['ui.router.state'])
    .controller('InputChavePixController', InputChavePixController)
    .component(InputChavePixComponent.selector, InputChavePixComponent)
    .name;
